import React from 'react';
import PropTypes from 'prop-types';
import { Router } from 'dva/router';
import App from './routes/app';

const registerModel = (app, model) => {
  if (!(app._models.filter(m => m.namespace === model.namespace).length === 1)) {
    app.model(model);
  }
};

const Routers = ({ history, app }) => {
  const routes = [
    {
      path: '/',
      component: App,
      getIndexRoute(nextState, cb) {
        require.ensure([], (require) => {
          registerModel(app, require('./models/purchase').default);
          registerModel(app, require('./models/sale').default);
          registerModel(app, require('./models/bank_transaction').default);
          registerModel(app, require('./models/general').default);

          cb(null, { component: require('./routes/file/').default });
        }, 'file');
      },
      childRoutes: [
        {
          path: '/file',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/purchase').default);
              registerModel(app, require('./models/sale').default);
              registerModel(app, require('./models/bank_transaction').default);
              registerModel(app, require('./models/general').default);

              cb(null, require('./routes/file/').default);
            }, 'file');
          },
        },
        {
          path: '/contact',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/contact').default);
              cb(null, require('./routes/contact/').default);
            }, 'contact');
          },
        },
        {
          path: '/employee',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/employee').default);
              cb(null, require('./routes/employee').default);
            }, 'employee');
          },
        },
        {
          path: '/item',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/item').default);
              cb(null, require('./routes/item').default);
            }, 'item');
          },
        },
        {
          path: '/general',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/general').default);
              cb(null, require('./routes/general').default);
            }, 'entry');
          },
        },
        {
          path: '/report/accounts-balance',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              cb(null, require('./routes/report/AccountsBalance').default);
            }, 'accountsBalanceReport');
          },
        },
        {
          path: '/report/account-ledger/:account_id',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              cb(null, require('./routes/report/AccountLedger').default);
            }, 'accountLedgerReport');
          },
        },
        {
          path: '/report/debt',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              cb(null, require('./routes/report/Debt').default);
            }, 'debtReport');
          },
        },
        {
          path: '/report/notice',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              cb(null, require('./routes/report/Notice').default);
            }, 'noticeReport');
          },
        },
        {
          path: '/purchase',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/purchase').default);
              registerModel(app, require('./models/payment').default);
              cb(null, require('./routes/purchase').default);
            }, 'purchase');
          },
        },
        {
          path: '/sale',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/sale').default);
              registerModel(app, require('./models/settings').default);
              registerModel(app, require('./models/payment').default);
              cb(null, require('./routes/sale').default);
            }, 'sale');
          },
        },
        {
          path: '/expense',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/expense').default);
              cb(null, require('./routes/expense').default);
            }, 'expense');
          },
        },
        {
          path: '/inventory',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/inventory').default);
              cb(null, require('./routes/inventory').default);
            }, 'inventory');
          },
        },
        {
          path: '/inventory/entry',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/inventory').default);
              cb(null, require('./routes/inventory/entry').default);
            }, 'inventoryEntry');
          },
        },
        {
          path: '/settings',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/settings').default);
              cb(null, require('./routes/settings/').default);
            }, 'settings');
          },
        },
        {
          path: '/report/tax',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/tax').default);
              cb(null, require('./routes/tax/').default);
            }, 'tax');
          },
        },
        {
          path: '/bank/transaction',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/bank_transaction').default);
              cb(null, require('./routes/bank/transaction/').default);
            }, 'bank_transaction');
          },
        },
        {
          path: '/bank/debt',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/payment').default);
              registerModel(app, require('./models/report').default);
              cb(null, require('./routes/bank/debt/').default);
            }, 'bank_debt');
          },
        },

        {
          path: '/salary/data',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/salary').default);
              cb(null, require('./routes/salary/data/').default);
            }, 'employee_expense_data');
          },
        },
        {
          path: '/salary/insurance',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/salary').default);
              cb(null, require('./routes/salary/insurance/').default);
            }, 'monthly_salary');
          },
        },
        {
          path: '/data',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/data').default);
              cb(null, require('./routes/data/').default);
            }, 'accounting_data');
          },
        },
        {
          path: '/cost/norm',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/cost').default);
              cb(null, require('./routes/cost/Norm').default);
            }, 'cost_norm');
          },
        },
        {
          path: '/cost/finished-good',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/cost').default);
              cb(null, require('./routes/cost/FinishedGood').default);
            }, 'cost_finished_good');
          },
        },
        {
          path: '/cost/sale',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/cost').default);
              cb(null, require('./routes/cost/Sale').default);
            }, 'cost_sale');
          },
        },
        {
          path: '/report/financial',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              registerModel(app, require('./models/settings').default);
              cb(null, require('./routes/report/Financial/').default);
            }, 'financialReport');
          },
        },
        {
          path: '/report/corp-income-tax',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              registerModel(app, require('./models/settings').default);
              cb(null, require('./routes/report/CorpIncomeTax/').default);
            }, 'corpIncomeTaxReport');
          },
        },
        {
          path: '/report/employee-income-tax',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              cb(null, require('./routes/report/EmployeeIncomeTax/').default);
            }, 'employeeIncomeTaxReport');
          },
        },
        {
          path: '/report/financial-detail',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              cb(null, require('./routes/report/FinancialDetail/').default);
            }, 'financialDetailReport');
          },
        },
        {
          path: '/report/general',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              cb(null, require('./routes/report/General/').default);
            }, 'generalReport');
          },
        },
        {
          path: '/report/analysis',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/report').default);
              cb(null, require('./routes/report/Analysis/').default);
            }, 'analysisReport');
          },
        },
        {
          path: '/export',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              cb(null, require('./routes/export/').default);
            }, 'exportPage');
          },
        },
        {
          path: '/space',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              cb(null, require('./routes/space/').default);
            }, 'listSpacesPage');
          },
        },
        {
          path: '/activity',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/notification').default);
              cb(null, require('./routes/activity/').default);
            }, 'activityPage');
          },
        },
        {
          path: '/comment',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/comment').default);
              cb(null, require('./routes/comment/').default);
            }, 'commentPage');
          },
        },
        {
          path: '/payment',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              cb(null, require('./routes/payment/').default);
            }, 'paymentPage');
          },
        },
        {
          path: '/cost/expense-distribution',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/expense_distribution').default);
              cb(null, require('./routes/cost/ExpenseDistribution').default);
            }, 'expenseDistributionPage');
          },
        },
        {
          path: '/space/report',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/space').default);
              cb(null, require('./routes/space/Report').default);
            }, 'taxReportDataPage');
          },
        },
        {
          path: '*',
          getComponent(nextState, cb) {
            require.ensure([], (require) => {
              cb(null, require('./routes/error/').default);
            }, 'error');
          },
        },
      ],
    },
  ];

  return <Router history={history} routes={routes} />;
};

Routers.propTypes = {
  history: PropTypes.object,
  app: PropTypes.object,
};

export default Routers;



// WEBPACK FOOTER //
// ./src/router.js